import { HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'
import { RequestType } from 'managed-analytics/domain/RequestType'

export type ZendeskRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class ZendeskRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: ZendeskRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async requestZendesk(
    requestType: RequestType,
    description: string,
    reportName: string,
    config?: HttpClientConfig,
    tags?: string[]
  ) {
    const endpoint = '/zendeskrequest'
    const payload = {
      type: requestType,
      reportName: reportName,
      description,
      ...(tags && tags.length > 0 ? { tags } : {}),
    }
    await this.httpClient.post(endpoint, payload, config)
  }
}
